import { createFileRoute } from "@tanstack/react-router";
import AdminPartsSearchTest from "@/pages/admin/AdminPartsSearchTest";

export const Route = createFileRoute("/_adminLayout/admin/parts-search-test")({
  component: AdminPartsSearchTest,
});
